import { combineReducers } from 'redux'

import modal from './modal/eventModal.reducer'
import securitySearch from './securitySearch.reducer'

export default combineReducers({
  modal,
  securitySearch
})
